import { Action } from "redux";
import { AuthGroup } from "../model";

export const SET_AUTH_GROUPS = "SET_AUTH_GROUPS";

export interface AuthGroupsAction extends Action<string> {
    authGroups: AuthGroup[];
}